import type { GroupedApprovals } from '../../queries/approvals/approvalsUtils';
import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type ActivityState = {
	activity: {
		filters: {
			team: string;
			member: string;
		};
		options: {
			teamOptions: TeamOptions[];
			memberOptions: MemberOptions[];
		};
		list: GroupedApprovals;
		filteredList: GroupedApprovals;
		viewAllApprovals: boolean;
	};
};

type AcitivityActions = {
	setActivityFilters: (filters: ActivityState['activity']['filters']) => void;
	setActivityOptions: (options: ActivityState['activity']['options']) => void;
	setUiActivities: (list: ActivityState['activity']['list']) => void;
	setFilteredList: (filteredList: ActivityState['activity']['filteredList']) => void;
	setViewAllApprovals: (viewAllApprovals: ActivityState['activity']['viewAllApprovals']) => void;
};

export type ActivitySlice = ActivityState & AcitivityActions;

type TeamOptions = { id: string; label: string };
type MemberOptions = { id: string; label: string };

const activityInitialState: ActivityState = {
	activity: {
		filters: {
			team: 'all',
			member: 'all',
		},
		options: {
			teamOptions: [{ id: 'all', label: 'All Teams' }],
			memberOptions: [{ id: 'all', label: 'All Members' }],
		},
		list: {
			pending: { approvals: [], count: 0 },
			approved: { approvals: [], count: 0 },
			declined: { approvals: [], count: 0 },
			canceled: { approvals: [], count: 0 },
		},
		filteredList: {
			pending: { approvals: [], count: 0 },
			approved: { approvals: [], count: 0 },
			declined: { approvals: [], count: 0 },
			canceled: { approvals: [], count: 0 },
		},
		viewAllApprovals: false,
	},
};

export function activitySlice(set: NamedSet<ZustandStore>): ActivitySlice {
	return {
		...activityInitialState,
		setActivityFilters(filters: ActivityState['activity']['filters']): void {
			set(
				(state: ActivityState) => {
					state.activity.filters = filters;
					return state;
				},
				false,
				'[setActivityFilters]',
			);
		},
		setActivityOptions(options: ActivityState['activity']['options']): void {
			set(
				(state: ActivityState) => {
					state.activity.options = options;
					return state;
				},
				false,
				'[setActivityOptions]',
			);
		},
		setUiActivities(list: ActivityState['activity']['list']): void {
			set(
				(state: ActivityState) => {
					state.activity.list = list;
					return state;
				},
				false,
				'[setUiActivities]',
			);
		},
		setFilteredList(filteredList: ActivityState['activity']['filteredList']): void {
			set(
				(state: ActivityState) => {
					state.activity.filteredList = filteredList;
					return state;
				},
				false,
				'[setFilteredList]',
			);
		},
		setViewAllApprovals(viewAllApprovals: ActivityState['activity']['viewAllApprovals']): void {
			set(
				(state: ActivityState) => {
					state.activity.viewAllApprovals = viewAllApprovals;
					return state;
				},
				false,
				'[setViewAllApprovals]',
			);
		},
	};
}
